import { render, staticRenderFns } from "./tablePerson.vue?vue&type=template&id=295b030a"
import script from "./tablePerson.vue?vue&type=script&lang=js"
export * from "./tablePerson.vue?vue&type=script&lang=js"
import style0 from "./tablePerson.vue?vue&type=style&index=0&id=295b030a&prod&lang=css"
import style1 from "./tablePerson.vue?vue&type=style&index=1&id=295b030a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports